import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/common-icon/close-white.svg';
const _withScopeId = n => (_pushScopeId("data-v-3aaaf18e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "mask"
};
const _hoisted_2 = {
  class: "popup"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createElementVNode("img", {
  class: "imgClose",
  src: _imports_0
})], -1));
const _hoisted_4 = [_hoisted_3];
const _hoisted_5 = {
  class: "popup-text"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "*", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "popup-hr"
}, null, -1));
const _hoisted_8 = {
  class: "popup-button"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createBlock(_Teleport, {
    to: "body"
  }, [$props.visible ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_Transition, {
    name: "down"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
      class: "popup-close",
      onClick: _cache[0] || (_cache[0] = (...args) => $setup.handleClose && $setup.handleClose(...args))
    }, _hoisted_4), _createElementVNode("div", _hoisted_5, [_createTextVNode(_toDisplayString($props.text) + " ", 1), _createElementVNode("div", {
      class: _normalizeClass(["popup-warn", {
        isWarn: $props.warnActive == true
      }])
    }, [_hoisted_6, _createTextVNode(" " + _toDisplayString($props.warnText), 1)], 2)]), _hoisted_7, _createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
      class: "popup-button-confirm",
      onClick: _cache[1] || (_cache[1] = (...args) => $setup.operate1 && $setup.operate1(...args))
    }, _toDisplayString($props.operate1Text), 1), _createElementVNode("div", {
      class: "popup-button-cancle",
      onClick: _cache[2] || (_cache[2] = (...args) => $setup.operate2 && $setup.operate2(...args))
    }, _toDisplayString($props.operate2Text), 1)])])]),
    _: 1
  })])) : _createCommentVNode("", true)]);
}